module.exports = __webpack_public_path__ + "static/media/crane2.de113cf6.png";